export default "__VITE_ASSET__Bqa6$c2r__"